/**
 * Дефолтный размер страницы для всех табличных списков
 * (компании, юр. лица, сотрудники, контакты, прайсы, менеджеры,
 * пользователи и приглашения).
 *
 * Если где-то нужен другой размер — передай его явно через prop
 * `pageSize` у DataTable, не правь это значение.
 */
export const DEFAULT_PAGE_SIZE = 15;
